import { useEffect, useState } from 'react';
import { useLatest, useToggle } from '@fuxi/eevee-hooks';
import { get } from 'lodash-es';

import { specialInnerCodeMap, useNECaptcha } from '@yaotai/common-utils';
import { VerificationCodeInputProps } from '.';

const CountdownTimeUnit = 1000;

export function useVerificationCodeInput({
  countdownTime = 90,
  value,
  validate,
  phoneNumber,
  onChange,
  msgRequest,
}: Partial<VerificationCodeInputProps>) {
  const [code, setCode] = useState(value);
  const [countDownTime, setCountDownTime] = useState(0);
  const [isGettingCode, { toggle }] = useToggle();
  const { captchaIns, getCaptchaIns } = useNECaptcha({
    mode: 'bind',
    onVerify: function (err: any, data: any) {
      if (err) return;
      onGetCodeBtnClick(data.validate);
    },
  });
  const latestPhone = useLatest(phoneNumber);

  const handleCodeChange = (code: string) => {
    setCode(code);
    onChange?.(code);
  };

  const handleFrequentCodeChange = (code: string | number) => {
    setCode('');
    onChange?.(String(code));
  };

  const onGetCodeBtnClick = async (valid?: string) => {
    // 校验函数和 phoneNumber 二者至少传其一 如果校验函数用于校验手机号，则优先拿取校验函数返回的经过校验的手机号
    const validatePhone = await validate?.();
    const phone = validatePhone ?? latestPhone.current;
    toggle();
    handleCodeChange('');
    const data = await msgRequest!(phone, valid!).finally(() => getCaptchaIns()?.refresh());
    const code = get(data, 'code', '0') as string | number;
    switch (code) {
      case specialInnerCodeMap['getCodeFrequent']:
        handleFrequentCodeChange(code);
        break;
      case specialInnerCodeMap['getCodeFrequentAndLaterTry']:
        handleFrequentCodeChange(code);
        break;
      default:
        return;
    }
  };

  const handleCaptcha = async () => {
    await validate?.();
    captchaIns?.verify();
  };

  const onCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => handleCodeChange(e.target.value);

  useEffect(() => {
    setCountDownTime(Date.now() + countdownTime * CountdownTimeUnit);
  }, [isGettingCode]);

  return {
    handleCaptcha,
    code,
    countDownTime,
    isGettingCode,
    onCodeChange,
    toggle,
  };
}
